"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;
  var getChildrenKey = function getChildrenKey(child) {
    return child ? child.key : 'empty';
  };
  if (props.children.length && nextProps.children.length) {
    var oldKeys = _react.default.Children.map(props.children, getChildrenKey);
    var oldKey = oldKeys[props.index];
    if (oldKey !== null && oldKey !== undefined) {
      var newKeys = _react.default.Children.map(nextProps.children, getChildrenKey);
      var newKey = newKeys[nextProps.index];
      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }
  return displaySameSlide;
};
var _default = getDisplaySameSlide;
exports.default = _default;